import { gql, useQuery } from 'urql';

const QrCodeQuery = gql`
  query GetTicketQrcode($hash: String!, $qrCodeSize: Int!) {
    getTicketQrcode(input: { hash: $hash, qrCodeSize: $qrCodeSize }) {
      qr
      firstName
      lastName
      eventName
      dateStart
      dateEnd
      status
      isDefaultEvent
      categories {
        title
        color
      }
      additionalGuests {
        adultCounter
        childCounter
        childGuestLabel
        adultGuestsLabel
        childGuests {
          firstName
          lastName
          surname
          ticketType
        }
        adultGuests {
          firstName
          lastName
          surname
          ticketType
        }
      }
    }
  }
`;

export interface CategoryData {
  title: string;
  color: string | null;
}

export interface GuestsData {
  firstName: string;
  lastName: string;
  surname: string;
  ticketType: string;
}

export interface AdditionalGuestsData {
  adultCounter: number;
  childCounter: number;
  childGuestLabel: string;
  adultGuestsLabel: string;
  childGuests: GuestsData[];
  adultGuests: GuestsData[];
}

export interface TicketInfo {
  qr: string;
  firstName: string;
  lastName: string;
  eventName: string;
  dateStart: string;
  dateEnd: string;
  status: string;
  isDefaultEvent: boolean;
  categories: CategoryData[];
  additionalGuests: AdditionalGuestsData;
}

interface QrCodeResponse {
  getTicketQrcode: TicketInfo;
}

const useFetchQrCode = (id: string, qrCodeSize: number) => {
  const [result, reexecute] = useQuery<QrCodeResponse>({
    query: QrCodeQuery,
    variables: { hash: id, qrCodeSize },
    requestPolicy: 'network-only',
  });
  const refetch = () => reexecute({ requestPolicy: 'network-only' });
  const { data, fetching, error } = result;
  return {
    data,
    fetching,
    error,
    refetch,
  };
};
export default useFetchQrCode;
